import React, { useState } from 'react';
import { Table } from 'antd';
import { useT } from 'hooks/Locale/useT';
import CommentModal from '../Modals/CommentModal';
import { TagStatus } from 'ui/Tag/types';
import { Button, Tag } from 'ui';
import CertModal from '../Modals/CertModal';
import generalHelpers from 'utils/generalHelpers';
import GradingModel from 'components/Grading/GradingModal';

interface CertificateTableInterface {
    data: any[];
    onReload?: Function;
}

const CertificateTable: React.FC<CertificateTableInterface> = ({ data, onReload }) => {
    const t = useT();
    const [showCommentModal, setShowCommentModal] = useState<any>([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedAttemptData, setSelectedAttemptData] = useState<any>(null);

    const columns = [
        {
            title: t('general.status'),
            dataIndex: 'status',
            render: (status: TagStatus) => (status ? <Tag status={status} /> : null),
        },
        {
            title: t('program.result_comment'),
            render: (_text: string, record: any) => (
                <div
                    className={record?.comment ? 'pointer' : ''}
                    onClick={() => (record.comment ? setShowCommentModal(record.comment) : null)}
                >
                    <i
                        className={
                            'fa-sharp fa-regular fa-comment-check' +
                            (record?.comment ? '' : 'disabled')
                        }
                    ></i>
                </div>
            ),
        },
        {
            title: t('program.total_time_spent'),
            dataIndex: 'timeSpent',
            render: (time: number) => (time ? generalHelpers.toHoursAndMinutes(time) : '-'),
        },
        {
            title: t('program.view_cert_details'),
            render: (_text: string, record: any) => {
                if (record?.submission) {
                    return (
                        <>
                            <Button
                                type={'link'}
                                onClick={() => setShowModal(true)}
                                message={'program.view_cert'}
                            />
                            <CertModal
                                open={showModal}
                                onCancel={setShowModal}
                                submission={record.submission}
                            />
                        </>
                    );
                }
            },
        },
        {
            title: t('grading.view'),
            render: (_text: string, record: any) => {
                if (!record.attemptId || !record.submissionId) {
                    return null;
                }

                // 24.3.9: grade view/edit entry point (same grading modal as "Vērtēšana")
                return (
                    <div
                        className="pointer"
                        onClick={() => {
                            setSelectedAttemptData({
                                attemptId: record.attemptId,
                                type: 'CERTIFICATE',
                                submissionId: record.submissionId,
                            });
                        }}
                    >
                        <i className="fa-sharp fa-light fa-diagram-subtask"></i>
                    </div>
                );
            },
        },
    ];

    return (
        <>
            <Table
                columns={columns}
                dataSource={data}
                rowKey={'id'}
                pagination={{ position: [] }}
            />
            <CommentModal open={showCommentModal} onCancel={setShowCommentModal} />
            <GradingModel
                onCancel={() => {
                    setSelectedAttemptData(null);
                }}
                attemptData={selectedAttemptData}
                onGraded={() => {
                    setSelectedAttemptData(null);
                    onReload?.();
                }}
            />
        </>
    );
};

export default CertificateTable;
